/**
 * Hidden Developer Logs Page
 * 
 * Secret page only accessible via direct URL.
 * Not visible in navigation or to regular users.
 */

import React from 'react'
import { DevLogsPortal } from '@/components/DevLogsPortal'
import { GlobalDevShortcuts } from '@/components/GlobalDevShortcuts'
import { ArrowLeft } from 'lucide-react'

export default function DevLogsPage() {
  return (
    <>
      <GlobalDevShortcuts />
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 md:p-8">
      <div className="max-w-[1600px] mx-auto">
        {/* Header */}
        <div className="mb-6 flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
              <span className="text-4xl">🔧</span>
              Developer Logs Portal
            </h1>
            <p className="text-sm text-gray-600 mt-1">
              Hidden debugging portal - Not accessible to regular users
            </p>
          </div>
          <button
            onClick={() => window.history.back()}
            className="flex items-center gap-2 px-4 py-2 bg-white rounded-xl shadow-sm hover:shadow-md transition border border-gray-200"
          >
            <ArrowLeft className="h-4 w-4" />
            Go Back
          </button>
        </div>

        {/* Logs Portal */}
        <DevLogsPortal />

        {/* Footer Hint */}
        <div className="mt-6 p-4 bg-purple-50 border border-purple-200 rounded-2xl">
          <p className="text-sm text-purple-900">
            💡 <strong>Pro Tip:</strong> Bookmark this URL for quick access. Press{' '}
            <kbd className="px-2 py-1 bg-white border border-purple-300 rounded text-xs font-mono">
              Ctrl+Shift+L
            </kbd>{' '}
            (or Cmd+Shift+L on Mac) from anywhere in the app to jump here.
          </p>
        </div>
      </div>
    </div>
    </>
  )
}
